<div class="modal-header">
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span class="color-close" aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="container">
    <div class="row">
      <div class="col col-12">
        <form [formGroup]="businessDigitalSurveyForm">
          <div class=" form-group mb-3">
            <label class="label-ng-select">Del 1 al 5, donde 1 es "Nada confiado" y 5 es "Muy confiado", ¿qué tan seguro
              te sientes hoy
              manejando tu negocio?</label>
            <ng-select class="custom" placeholder="Selecciona una opción" formControlName="business_confidence">
              <ng-option *ngFor="let option of surveyScaleOptions" [value]="option.value">{{ option.label }}</ng-option>
            </ng-select>
          </div>

          <div class="form-group mb-3">
            <label class="label-ng-select">Del 1 al 5, donde 1 es "Nada de conocimiento" y 5 es "Mucho conocimiento",
              ¿cómo calificarías lo que
              sabes sobre herramientas financieras para tu negocio?</label>
            <ng-select class="custom" placeholder="Selecciona una opción" formControlName="financial_knowledge">
              <ng-option *ngFor="let option of surveyScaleOptions" [value]="option.value">{{ option.label }}</ng-option>
            </ng-select>
          </div>

          <div class="form-group mb-3">
            <label class="label-ng-select">¿Hoy en día usas alguna herramienta digital nueva en tu negocio? (como un
              sistema de cobro,
              inventarios o atención a clientes)</label><br>
            <div class="row margin-radio">
              <div class="col-lg-2">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="toolYes" name="uses_digital_tool" class="custom-control-input green"
                    [value]="true" formControlName="uses_digital_tool" />
                  <label class="custom-control-label label-gender" for="toolYes">
                    Sí
                  </label>
                </div>
              </div>

              <div class="offset-lg-2 col-lg-2">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="toolNo" name="uses_digital_tool" class="custom-control-input green"
                    [value]="false" formControlName="uses_digital_tool" />
                  <label class="custom-control-label label-gender" for="toolNo">
                    No
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group mb-3">
            <label class="label-ng-select">¿Estás usando alguna herramienta digital para dar a conocer o llevar el
              control de tu negocio? (como
              redes sociales, tienda en línea o sistemas de inventario)</label><br>
            <div class="row margin-radio">
              <div class="col-lg-2">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="controlYes" name="uses_digital_control" class="custom-control-input green"
                    [value]="true" formControlName="uses_digital_control" />
                  <label class="custom-control-label label-gender" for="controlYes">Sí</label>
                </div>
              </div>

              <div class="offset-lg-2 col-lg-2">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="controlNo" name="uses_digital_control" class="custom-control-input green"
                    [value]="false" formControlName="uses_digital_control" />
                  <label class="custom-control-label label-gender" for="controlNo">No</label>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group mb-3">
            <label class="label-ng-select">¿Hoy en día usas algo nuevo para cobrar o financiar tu negocio? (como pagos
              con tarjeta, terminal
              para tarjetas, billeteras digitales o líneas de crédito)</label><br>
            <div class="row margin-radio">
              <div class="col-lg-2">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="paymentYes" name="uses_payment_methods" class="custom-control-input green"
                    [value]="true" formControlName="uses_payment_methods" />
                  <label class="custom-control-label label-gender" for="paymentYes">
                    Sí
                  </label>
                </div>
              </div>

              <div class="offset-lg-2 col-lg-2">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="paymentNo" name="uses_payment_methods" class="custom-control-input green"
                    [value]="false" formControlName="uses_payment_methods" />
                  <label class="custom-control-label label-gender" for="paymentNo">
                    No
                  </label>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer text-center d-flex justify-content-center">
  <button class="btn btn-primary" type="button" id="surveyButton" (click)="submitSurvey()">
    Continuar
  </button>
</div>
